import { useEffect, useState } from 'react';
import SelectInput from '../../../../components/Basic/Inputs/SelectWithInput';

export default function WarehouseSelect({
  warehouse = '',
  warehouses,
  onChange = () => { },
  label = '',
  searchParams = {},
  ...props
}) {
  const [list, setList] = useState(warehouses);
  const [value, setValue] = useState(warehouse || '');
  const findWarehouse = (search) => {
    setList(warehouses.filter(l => l.name.match(new RegExp(search.replaceAll(/\(/g, "\\(").replaceAll(/\)/g, "\\)"), 'gi'))));
  };

  const onSelect = (v) => {
    onChange(v);
    // setValue(warehouse)
  };

  const onBlur = () => {
    if (value === '') {
      onChange({})
    } else if (warehouse) {
      setValue(warehouse)
    }
  };

  useEffect(() => {
    setValue(warehouse);
  }, [warehouse]);

  const onChangeInput = (v) => {
    setValue(v);
    findWarehouse(v || '');
  };

  return (
    <SelectInput
      label={label}
      select={value}
      list={list}
      valueFn={v => v.name}
      preventState={true}
      add={false}
      placeholder={'Не выбрано'}
      {...props}
      isOk={null}
      onBlur={onBlur}
      onChange={onChangeInput}
      onSelect={onSelect}
      onFocus={(v) => findWarehouse(v || '')}
    />
  );
}
